/**
 * Default mock cart data for demo mode
 */

import type { Schemas } from "@fluid-app/fluid";

type CartData = Schemas["Cart"];

/**
 * Default mock cart with a regular product and a subscription product
 */
export const defaultMockCart: CartData = {
  id: 123,
  recurring: [],
  items: [
    {
      id: 1,
      variant: {
        id: 101,
        image_url: "https://placehold.co/600x400?text=Demo+Product",
        price_in_currency: "$24.99",
        image_path: "https://placehold.co/600x400?text=Demo+Product",
        price: "$24.99",
        primary_image: "https://placehold.co/600x400?text=Demo+Product",
        sku: "SKU123",
        title: "Demo Product",
      },
      quantity: 2,
      product_title: "Demo Product",
      price_in_currency: "$24.99",
      product: {
        image_url: "https://placehold.co/600x400?text=Demo+Product",
      },
    },
    {
      id: 2,
      variant: {
        id: 102,
        image_url: "https://placehold.co/600x400?text=Subscription+Product",
        price_in_currency: "$34.99",
        image_path: "https://placehold.co/600x400?text=Subscription+Product",
        price: "$34.99",
        primary_image: "https://placehold.co/600x400?text=Subscription+Product",
        sku: "SKU456",
        title: "Subscription Product",
      },
      quantity: 1,
      product_title: "Subscription Product",
      price_in_currency: "$34.99",
      subscription_price_in_currency: "$27.99",
      product: {
        image_url: "https://placehold.co/600x400?text=Subscription+Product",
      },
      allow_subscription: true,
      subscription: true,
      subscription_interval: 1,
      subscribe_and_save_for_display: "Save 20%",
    },
    {
      id: 3,
      variant: {
        id: 103,
        image_url: "https://placehold.co/600x400?text=Toggle+Product",
        price_in_currency: "$49.99",
        image_path: "https://placehold.co/600x400?text=Toggle+Product",
        price: "$49.99",
        primary_image: "https://placehold.co/600x400?text=Toggle+Product",
        sku: "SKU789",
        title: "Toggle Subscription Product",
      },
      quantity: 1,
      product_title: "Toggle Subscription Product",
      price_in_currency: "$49.99",
      subscription_price_in_currency: "$39.99",
      product: {
        image_url: "https://placehold.co/600x400?text=Toggle+Product",
      },
      allow_subscription: true,
      subscription: false,
      subscription_interval: 1,
      subscribe_and_save_for_display: "Save $10.00",
    },
  ],
  sub_total_in_currency: "$137.96",
};

/**
 * Mock cart with an enrollment pack
 */
export const mockCartWithEnrollmentPack: CartData = {
  id: 456,
  recurring: [],
  items: [
    {
      id: 4,
      variant: {
        id: 201,
        image_url: "https://placehold.co/600x400?text=Enrollment+Item+1",
        price_in_currency: "$49.99",
        image_path: "https://placehold.co/600x400?text=Enrollment+Item+1",
        price: "$49.99",
        primary_image: "https://placehold.co/600x400?text=Enrollment+Item+1",
        sku: "SKU789",
        title: "Enrollment Pack Item 1",
      },
      quantity: 1,
      product_title: "Enrollment Pack Item 1",
      price_in_currency: "$49.99",
      product: {
        image_url: "https://placehold.co/600x400?text=Enrollment+Item+1",
      },
      enrollment: true,
    },
    {
      id: 5,
      variant: {
        id: 202,
        image_url: "https://placehold.co/600x400?text=Enrollment+Item+2",
        price_in_currency: "$39.99",
        image_path: "https://placehold.co/600x400?text=Enrollment+Item+2",
        price: "$39.99",
        primary_image: "https://placehold.co/600x400?text=Enrollment+Item+2",
        sku: "SKU012",
        title: "Enrollment Pack Item 2",
      },
      quantity: 1,
      product_title: "Enrollment Pack Item 2",
      price_in_currency: "$39.99",
      product: {
        image_url: "https://placehold.co/600x400?text=Enrollment+Item+2",
      },
      enrollment: true,
    },
    {
      id: 6,
      variant: {
        id: 203,
        image_url: "https://placehold.co/600x400?text=Regular+Product",
        price_in_currency: "$19.99",
        image_path: "https://placehold.co/600x400?text=Regular+Product",
        price: "$19.99",
        primary_image: "https://placehold.co/600x400?text=Regular+Product",
        sku: "SKU345",
        title: "Regular Product",
      },
      quantity: 1,
      product_title: "Regular Product",
      price_in_currency: "$19.99",
      product: {
        image_url: "https://placehold.co/600x400?text=Regular+Product",
      },
    },
  ],
  sub_total_in_currency: "$109.97",
  enrollment_pack: {
    enrollment_pack_id: 123,
    title: "Demo Enrollment Pack",
    price_in_currency: "$89.98",
  },
};

/**
 * Mock empty cart
 */
export const mockEmptyCart: CartData = {
  id: 0,
  recurring: [],
  items: [],
  sub_total_in_currency: "$0.00",
};
